import { useEffect } from 'react';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';
import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { TUpdate } from 'domain/types';
import { showSystemToast } from 'view/components/SystemToast';

export const useDeleteUser = (): any => {
  const navigate = useNavigate();
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, error, status, send } = useRequest({
    url: '/api/v1/auth/me',
    method: ApiMethodsEnum.Delete,
    sendOnStart: false,
  });

  useEffect(() => {
    if (!isLoading && !error && status === 204) {
      storageService.removeItem('accessToken').then();
      storageService.removeItem('refreshToken').then();
      if (update) update({ isOpenDeleteAccountModal: false });
      navigate('/auth/login', { replace: true });
      showSystemToast(
        'success',
        'Account deleted',
        'Your account and all associated data have been permanently removed.'
      );
    }
  }, [isLoading, error, status]);

  return {
    isLoading,
    error: error || null,
    send,
  };
};
